import { translate } from './i18n';
import {
  RfiCategory,
  RfiCostImpact,
  RfiDiscipline,
  RfiPriority,
  RfiScheduleImpact,
} from '../sdk/types';
import { ISSUE_ATTRIBUTE_NAMES } from '../constants';

export type RfiMultiselectEnumsOptionsMapping = Record<
  'discipline' | 'category',
  readonly string[]
>;
export type RfiSingleSelectEnumsOptionsMapping = Record<
  'costImpact' | 'scheduleImpact' | 'priority',
  readonly string[]
>;

type RfiEnumsOptionsMappingType = RfiMultiselectEnumsOptionsMapping &
  RfiSingleSelectEnumsOptionsMapping;

const rfiEnumsOptionsMapping: RfiEnumsOptionsMappingType = {
  [ISSUE_ATTRIBUTE_NAMES.COST]: Object.values(RfiCostImpact),
  [ISSUE_ATTRIBUTE_NAMES.SCHEDULE]: Object.values(RfiScheduleImpact),
  [ISSUE_ATTRIBUTE_NAMES.PRIORITY]: Object.values(RfiPriority),
  [ISSUE_ATTRIBUTE_NAMES.DISCIPLINE]: Object.values(RfiDiscipline),
  [ISSUE_ATTRIBUTE_NAMES.CATEGORY]: Object.values(RfiCategory),
};

export type EnumDropdownOption = {
  key: string;
  value: string;
  label: string;
};

export const toEnumOptionsArray = (arr?: readonly string[] | null): EnumDropdownOption[] =>
  arr ? arr.map((el) => ({ key: el, value: el, label: translate(el) })) : [];

export type GetRFIEnumOptionsArgs = {
  enumName: keyof typeof rfiEnumsOptionsMapping;
  withUnspecified: boolean;
};

export const getRFIEnumOptions = (
  enumName: keyof typeof rfiEnumsOptionsMapping,
  withUnspecified = false,
) => {
  const definedEnumValues: readonly string[] = rfiEnumsOptionsMapping[enumName] || [];
  const enumValues = withUnspecified ? [...definedEnumValues, 'Unspecified'] : definedEnumValues;
  return toEnumOptionsArray(enumValues);
};
